import React, { useState } from 'react';
import HorizontalBarCard from 'src/App/Dashboards/Market/Components/Cards/HorizontalBar';
import { parseGuest } from 'src/utils/functions';
import { GRAPH_BLUE } from 'src/utils/colors';
import NoDataCard from 'src/App/Dashboards/Market/Components/Cards/NoDataCard';

const TopCitiesCard = ({
  graph,
  isDisabled,
  handleOnSampleClick,
  matches,
  userTailorMarketAccess,
  warningTextComponent,
  setSelectedGraphExportDetails,
  noDataInMarket
}: {
  graph;
  isDisabled: boolean;
  handleOnSampleClick: any;
  matches: boolean;
  userTailorMarketAccess: boolean;
  warningTextComponent: any;
  setSelectedGraphExportDetails: any;
  noDataInMarket: boolean;
}) => {
  const GRAPH_LIMIT = 5;
  const [graphLimit, setGraphLimit] = useState<number>(GRAPH_LIMIT);
  const dummyData = {
    London: 21.1,
    Brighton: 3.8,
    Bristol: 1.5,
    Reading: 1.2,
    Manchester: 1.1,
    Portsmouth: 0.9,
    Bournemouth: 0.8,
    Birmingham: 0.7,
    Cambridge: 0.7,
    Paris: 0.7,
  };

  const onCTAClick = () => {
    setGraphLimit(prevLimit => (prevLimit === GRAPH_LIMIT ? -1 : GRAPH_LIMIT));
  };

  if (noDataInMarket) {
    return <NoDataCard height={150} borderRadius={8} />;
  }

  return (
    <>
      <HorizontalBarCard
        title="Top Guest Origin Cities"
        data={isDisabled ? dummyData : parseGuest(graph.data?.guest_origin?.cities)}
        color={GRAPH_BLUE}
        unit="%"
        isDisabled={isDisabled}
        handleOnSampleClick={handleOnSampleClick}
        graphLimit={graphLimit}
        onCTAClick={onCTAClick}
        matches={matches}
        userTailorMarketAccess={userTailorMarketAccess}
        tooltipSuffix={' of total guests'}
        parent="guest_origin_cities"
        warningTextComponent={warningTextComponent}
        setSelectedGraphExportDetails={setSelectedGraphExportDetails}
      />
    </>
  );
};

export default TopCitiesCard;
